import React, { useState } from "react";
import { FaPlay, FaImages } from "react-icons/fa";

const RentalBook = () => {
  const [showModal, setShowModal] = useState(false);
  const [showEnquiryModal, setShowEnquiryModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
const [formData, setFormData] = useState({
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  message: ""
});

  // Sample images for the screenshot gallery
  const screenshotImages = [
    "/images/rental/Frame 1000004752.png",
    "/images/rental/Frame 1000004753.png",
    "/images/rental/Frame 1000004754.png",
    "/images/rental/Frame 1000004755.png",
    "/images/rental/Frame 1000004756.png",
    "/images/rental/Frame 1000004757.png",
    "/images/rental/Frame 1000004758.png",
    "/images/rental/Frame 1000004759.png",
    "/images/rental/Frame 1000004760.png",
    "/images/rental/Frame 1000004761.png"
  ];

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === screenshotImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? screenshotImages.length - 1 : prevIndex - 1
    );
  };

const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData({
    ...formData,
    [name]: value
  });
};

const handleSubmit = async (e) => {
  e.preventDefault();
  
  try {
    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      phonenumber: formData.phone,
      email: formData.email,
      message: formData.message,
      type: "contact"
    };

    const response = await fetch("https://tnreaders.in/web/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      console.log("Form submitted successfully");
      // Reset form and close modal
      setFormData({ 
        firstName: "", 
        lastName: "", 
        phone: "", 
        email: "", 
        message: "" 
      });
      setShowEnquiryModal(false);
      alert("Thank you for your enquiry! We'll contact you soon.");
    } else {
      throw new Error("Failed to submit form");
    }
  } catch (error) {
    console.error("Error submitting form:", error);
    alert("There was an error submitting your form. Please try again.");
  }
};
  return (
    <div className="carento-product">
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-modal" onClick={() => setShowModal(false)}>
              &times;
            </button>
            <div className="image-container">
              <img
                src={screenshotImages[currentImageIndex]}
                alt={`Screenshot ${currentImageIndex + 1}`}
              />
            </div>
            <div className="modal-navigation">
              <button className="nav-arrow" onClick={handlePrevImage}>
                &larr; Previous
              </button>
              <span className="image-counter">
                {currentImageIndex + 1} / {screenshotImages.length}
              </span>
              <button className="nav-arrow" onClick={handleNextImage}>
                Next &rarr;
              </button>
            </div>
          </div>
        </div>
      )}
{showEnquiryModal && (
  <div className="modal-overlay">
    <div className="modal-content enquiry-form">
      <button
        className="close-modal"
        onClick={() => setShowEnquiryModal(false)}
      >
        &times;
      </button>
      <h2>Request Demo</h2>
      <p>Please fill out this form to request a demo of our product.</p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="firstName">First Name:</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="lastName">Last Name:</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone:</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>

        <button type="submit" className="submit-btn">
          Submit Request
        </button>
      </form>
    </div>
  </div>
)}
      <div className="product-container">
        {/* Product Description Section */}
        <section className="product-description">
          <div className="section-header">
            <span className="section-badge">AUTOMOTIVE</span>
            <h1>MP - Car Dealer & Rental System</h1>
            <h2>Complete Vehicle Management and Booking Platform</h2>
          </div>
          <div className="description-content">
            <p>
              MP is a comprehensive Laravel-based solution for car
              dealerships and rental businesses. It combines vehicle inventory
              management with a powerful booking system, enabling businesses to
              showcase their fleet and manage rentals efficiently.
            </p>
            <div className="highlight-box">
              <p>
                <strong>Key Benefit:</strong> Dual functionality as both a car
                dealership management system and rental booking platform, saving
                businesses the cost of separate systems.
              </p>
            </div>
          </div>
        </section>

        <div className="btnalignmnt">
          <button
            className="livepreview"
            onClick={() => setShowEnquiryModal(true)}
          >
            <FaPlay style={{ marginRight: "8px" }} />
            Demo
          </button>
          <button className="screenshot" onClick={() => setShowModal(true)}>
            <FaImages style={{ marginRight: "8px" }} />
            Screenshots
          </button>
        </div>

        {/* Product Features Section */}
        <section className="product-features">
          <div className="section-header">
            <span className="section-badge">FEATURES</span>
            <h2>Automotive Business Capabilities</h2>
          </div>
          <div className="features-grid">
            {[
              {
                icon: "🚗",
                title: "Vehicle Inventory",
                description:
                  "Manage your entire vehicle fleet with detailed specifications and images"
              },
              {
                icon: "📅",
                title: "Booking System",
                description:
                  "Online reservations with availability calendar and instant confirmation"
              },
              {
                icon: "💰",
                title: "Payment Processing",
                description:
                  "Integrated payment gateways with secure transactions"
              },
              {
                icon: "📱",
                title: "Mobile Responsive",
                description:
                  "Fully responsive design works perfectly on all devices"
              },
              {
                icon: "📊",
                title: "Analytics Dashboard",
                description: "Track bookings, revenue, and vehicle utilization"
              },
              {
                icon: "📝",
                title: "Document Management",
                description:
                  "Store and manage rental agreements and driver licenses"
              }
            ].map((feature, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Technology Used Section */}
        <section className="technology-used">
          <div className="section-header">
            <span className="section-badge">TECHNOLOGY</span>
            <h2>Built for Automotive Businesses</h2>
          </div>
          <div className="tech-stack">
            <div className="tech-category">
              <div className="tech-header">
                <div className="tech-icon">💻</div>
                <h3>Frontend</h3>
              </div>
              <ul>
                <li>HTML5, CSS3, JavaScript (ES6+)</li>
                <li>Bootstrap 5 responsive framework</li>
                <li>jQuery for interactive components</li>
                <li>Date/time picker plugins</li>
              </ul>
            </div>

            <div className="tech-category">
              <div className="tech-header">
                <div className="tech-icon">🔌</div>
                <h3>Backend</h3>
              </div>
              <ul>
                <li>PHP 8.0+ (Laravel 9.x framework)</li>
                <li>MySQL relational database</li>
                <li>RESTful API architecture</li>
                <li>Redis for caching</li>
              </ul>
            </div>

            <div className="tech-category">
              <div className="tech-header">
                <div className="tech-icon">🛠️</div>
                <h3>Integrations</h3>
              </div>
              <ul>
                <li>Stripe/PayPal payment gateways</li>
                <li>Google Maps for location services</li>
                <li>SMTP/Amazon SES for notifications</li>
                <li>Twilio for SMS alerts</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Vehicle Types Section */}
        <section className="vehicle-types">
          <div className="section-header">
            <span className="section-badge">VEHICLES</span>
            <h2>Supported Vehicle Categories</h2>
          </div>
          <div className="types-grid">
            {[
              { icon: "🚙", type: "SUVs", count: "4x4, Crossovers" },
              { icon: "🚗", type: "Sedans", count: "Luxury, Economy" },
              { icon: "🚐", type: "Vans", count: "Passenger, Cargo" },
              {
                icon: "🏎️",
                type: "Sports Cars",
                count: "Coupes, Convertibles"
              },
              { icon: "🛻", type: "Trucks", count: "Pickups, Commercial" },
              { icon: "🛵", type: "Motorcycles", count: "Scooters, Touring" }
            ].map((vehicle, index) => (
              <div className="type-item" key={index}>
                <div className="type-icon">{vehicle.icon}</div>
                <h3>{vehicle.type}</h3>
                <p>{vehicle.count}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Booking Process Section */}
        <section className="booking-process">
          <div className="section-header">
            <span className="section-badge">WORKFLOW</span>
            <h2>Simple Rental Booking Process</h2>
          </div>
          <div className="process-steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Vehicle Selection</h3>
              <p>Customers browse available vehicles with filters</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Date & Time</h3>
              <p>Choose pickup/return dates and locations</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Extras & Options</h3>
              <p>Add insurance, GPS, or other accessories</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>Checkout</h3>
              <p>Secure payment and booking confirmation</p>
            </div>
          </div>
        </section>

        {/* Admin Features Section */}
        <section className="admin-features">
          <div className="section-header">
            <span className="section-badge">ADMIN</span>
            <h2>Powerful Management Tools</h2>
          </div>
          <div className="features-list">
            <div className="feature-column">
              <ul>
                <li>📅 Booking calendar overview</li>
                <li>🚗 Vehicle availability management</li>
                <li>📊 Financial reporting</li>
              </ul>
            </div>
            <div className="feature-column">
              <ul>
                <li>👤 Customer management</li>
                <li>📝 Contract generation</li>
                <li>🔔 Automated reminders</li>
              </ul>
            </div>
            <div className="feature-column">
              <ul>
                <li>📱 Mobile admin access</li>
                <li>🛠️ Maintenance scheduling</li>
                <li>📈 Performance analytics</li>
              </ul>
            </div>
          </div>
        </section>
      </div>

      {/* CSS Styles with Automotive Theme */}
      <style>{`
        :root {
          --primary-color: rgb(14,89,145);
          --secondary-color: #137eb1;
          --light-accent: #f3e5f5;
          --dark-shade: #4a148c;
          --text-color: #2d3748;
          --light-text: #f8fafc;
        }

                        .btnalignmnt{
          display: flex;
    justify-content: center;
    margin-bottom: 20px;
    gap: 10px;
    flex-wrap: wrap;
        }

.livepreview,
.screenshot {
  border: none;
  background: white;
  box-shadow: 0 5px 15px rgba(124, 1, 177, 0.05);
  border: 1px solid rgba(124, 1, 177, 0.1);
  padding: 10px 20px;
  border-radius: 10px;
  color: var(--primary-color);
  cursor: pointer;
  transition: all 0.3s ease;
}

.livepreview:hover,
.screenshot:hover {
  background-color: var(--primary-color);
  color: white;
  transform: scale(1.05);
  box-shadow: 0 8px 20px rgba(124, 1, 177, 0.15);
}

        
        .navigation-buttons {
          position: fixed;
          top: 20px;
          right: 20px;
          display: flex;
          gap: 10px;
          z-index: 1000;
        }
        
        .nav-button {
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          border: none;
          transition: all 0.3s ease;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }

                /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1001;
        }
        
        .modal-content {
          background: white;
          padding: 2rem;
          border-radius: 10px;
          max-width: 80%;
          max-height: 90%;
          position: relative;
          box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
        }
        
        .close-modal {
          position: absolute;
          top: 15px;
          right: 15px;
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          color: var(--text-color);
        }
        
        .image-container {
          margin: 1rem 0;
          text-align: center;
        }
        
        .image-container img {
          max-width: 100%;
          max-height: 500px;
          border-radius: 5px;
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
        }
        
        .modal-navigation {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 1rem;
        }
        
        .nav-arrow {
          background: var(--primary-color);
          color: white;
          border: none;
          padding: 0.5rem 1rem;
          border-radius: 5px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .nav-arrow:hover {
          background: var(--dark-shade);
        }
        
        .image-counter {
          font-weight: 600;
        }
        
        .carento-product {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          line-height: 1.6;
          color: var(--text-color);
          margin: 0 auto;
          padding: 0rem;
        }
        
        .product-container {
          background: white;
          border-radius: 16px;
          box-shadow: 0 10px 30px rgba(124, 1, 177, 0.1);
          padding: 2rem;
          overflow: hidden;
        }

                                .product-description{
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        }

                .technology-used{
          padding-top: 20px;
        }

        .property-types{
          padding-top: 20px;
        }

        .admin-features{
        padding-top: 20px;
        }
        
        .section-header {
          margin-bottom: 2rem;
          position: relative;
        }
        
        .section-badge {
          display: inline-block;
          background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
          color: white;
          padding: 0.35rem 1rem;
          border-radius: 50px;
          font-size: 0.75rem;
          font-weight: 600;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          margin-bottom: 1rem;
        }
        
        h1 {
          color: var(--primary-color);
          font-size: 2.5rem;
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 0.5rem;
        }
        
        h2 {
          color: var(--dark-shade);
          font-size: 1.75rem;
          font-weight: 600;
          margin-bottom: 1.5rem;
          position: relative;
        }
        
        h3 {
          color: var(--primary-color);
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 0.75rem;
        }
        
        p {
          margin-bottom: 1rem;
          color: var(--text-color);
          font-size: 1rem;
          line-height: 1.7;
        }
        
        .description-content {
          max-width: 800px;
        }
        
        .highlight-box {
          background: var(--light-accent);
          border-left: 4px solid var(--secondary-color);
          padding: 1.25rem;
          border-radius: 0 8px 8px 0;
          margin: 1.5rem 0;
        }
        
        .highlight-box p {
          margin: 0;
          color: var(--dark-shade);
        }
        
        .features-grid, .types-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 1.5rem;
        }
        
        .feature-card, .type-item {
          background: white;
          padding: 1.5rem;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(124, 1, 177, 0.05);
          border: 1px solid rgba(124, 1, 177, 0.1);
          transition: all 0.3s ease;
          text-align: center;
        }
        
        .feature-card:hover, .type-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(124, 1, 177, 0.15);
          border-color: rgba(124, 1, 177, 0.2);
        }
        
        .feature-icon, .type-icon {
          font-size: 2rem;
          margin-bottom: 1rem;
          color: var(--secondary-color);
        }
        
        .tech-stack {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-evenly;
            align-items: center;
            margin-bottom: 2rem;
        }
        
        .tech-category {
          background: white;
          padding: 1.5rem;
          border-radius: 10px;
          box-shadow: 0 5px 15px rgba(124, 1, 177, 0.05);
          border: 1px solid rgba(124, 1, 177, 0.1);
        }
        
        .tech-header {
          display: flex;
          align-items: center;
          margin-bottom: 1rem;
        }
        
        .tech-icon {
          font-size: 1.5rem;
          margin-right: 0.75rem;
          color: var(--secondary-color);
        }
        
        .process-steps {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 2rem;
        }
        
        .step {
          text-align: center;
          position: relative;
        }
        
        .step-number {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          margin: 0 auto 1rem;
        }
        
        .features-list {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 2rem;
        }
        
        .feature-column ul {
          padding-left: 0;
        }
        
        .feature-column li {
          margin-bottom: 1rem;
          position: relative;
          list-style-type: none;
          padding-left: 2rem;
          font-size: 1rem;
        }
        
        .feature-column li::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          font-size: 1.2rem;
        }

                                .enquiry-form {
  max-width: 500px;
  padding: 30px;
  background: white;
  border-radius: 8px;
}

.enquiry-form h2 {
  margin-top: 0;
  color: #2c3e50;
}

.enquiry-form p {
  margin-bottom: 20px;
  color: #7f8c8d;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
  text-align: left;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.submit-btn {
  background-color: rgb(14,89,145);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  transition: background-color 0.3s;
}

.submit-btn:hover {
  background-color: #137eb1;
}
        
        @media (max-width: 768px) {
          .product-container {
            padding: 1rem;
          }
          
          h1 {
            font-size: 2rem;
          }
          
          h2 {
            font-size: 1.5rem;
          }
          
          .features-grid, .tech-stack, .types-grid, .process-steps, .features-list {
            grid-template-columns: 1fr;
          }

                                            .btnalignmnt{
          display: flex;
    justify-content: center;
    margin-bottom: 20px;
    gap: 10px;
        }
        }
      `}</style>
    </div>
  );
};

export default RentalBook;
